const ADD_TASK = 'ADD_TASK';
const REMOVE_TASK = 'REMOVE_TASK';
const CLEAR_COMPLETED = 'CLEAR_COMPLETED';
const TOGGLE_COMPLETED = 'TOGGLE_COMPLETED';
const TOGGLE_SHOW = 'TOGGLE_SHOW';
const TOGGLE_THEME = 'TOGGLE_THEME';
const TOGGLE_AMOUNT = 'TOGGLE_AMOUNT';

export {
  ADD_TASK,
  REMOVE_TASK,
  CLEAR_COMPLETED,
  TOGGLE_COMPLETED,
  TOGGLE_SHOW,
  TOGGLE_THEME,
  TOGGLE_AMOUNT,
};
